import dayjs from 'dayjs';
import en from 'dayjs/locale/en';
import es from 'dayjs/locale/es';
import fr from 'dayjs/locale/fr';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

const locales = {
  en,
  es,
  fr
};
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.locale("en", locales.en);
dayjs.locale("es", locales.es);
dayjs.locale("fr", locales.fr);
function convertHumanDateToTimestamp(humanDate) {
  const date = /* @__PURE__ */ new Date();
  const duration = Number.parseInt(humanDate.split(" ")[0]);
  const unit = humanDate.split(" ")[1];
  switch (unit) {
    case "second":
    case "seconds":
      return date.setSeconds(date.getSeconds() - duration);
    case "minute":
    case "minutes":
      return date.setMinutes(date.getMinutes() - duration);
    case "hour":
    case "hours":
      return date.setHours(date.getHours() - duration);
    case "day":
    case "days":
      return date.setDate(date.getDate() - duration);
    case "week":
    case "weeks":
      return date.setDate(date.getDate() - duration * 7);
    case "month":
    case "months":
      return date.setMonth(date.getMonth() - duration);
    case "year":
    case "years":
      return date.setFullYear(date.getFullYear() - duration);
    default:
      return null;
  }
}
function format(date, format2 = "MMM D, YYYY", locale = "en") {
  return dayjs(date).locale(locale).format(format2);
}
function fromNow(date, locale = "en") {
  return dayjs(date).locale(locale).fromNow();
}
function getDayNumber(date) {
  return Number.parseInt(date.split("-")[2]);
}
function getDaysBetweenTwoDates(firstDate, secondDate) {
  if (typeof firstDate == "number") {
    firstDate = new Date(firstDate);
  }
  if (typeof secondDate == "number") {
    secondDate = new Date(secondDate);
  }
  firstDate.setHours(0, 0, 0, 0);
  secondDate.setHours(0, 0, 0, 0);
  return Math.round(Math.abs((+firstDate - +secondDate) / (24 * 60 * 60 * 1e3)));
}
function getDaysRangeBetweenTwoDates(startDate, stopDate, reverse = false) {
  if (typeof startDate == "number") {
    startDate = new Date(startDate);
  }
  if (typeof stopDate == "number") {
    stopDate = new Date(stopDate);
  }
  startDate.setHours(0, 0, 0, 0);
  stopDate.setHours(0, 0, 0, 0);
  const results = {};
  let days = [];
  const currentDate = startDate;
  while (currentDate <= stopDate) {
    days.push(currentDate.toISOString().split("T")[0]);
    currentDate.setDate(currentDate.getDate() + 1);
  }
  if (reverse) {
    days = days.reverse();
  }
  for (const day of days) {
    results[day] = null;
  }
  return results;
}
function getFirstAndLastDayOfLastTwelveMonth() {
  const today = /* @__PURE__ */ new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth() - 11, 1);
  const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  return {
    firstDay,
    lastDay
  };
}
function getFirstAndLastDayOfMonth(date) {
  const givenDate = date ? new Date(date) : /* @__PURE__ */ new Date();
  const firstDay = new Date(givenDate.getFullYear(), givenDate.getMonth(), 1);
  const lastDay = new Date(givenDate.getFullYear(), givenDate.getMonth() + 1, 0);
  return {
    firstDay,
    lastDay
  };
}
function getFirstAndLastDayOfWeek(date) {
  const givenDate = date ? new Date(date) : /* @__PURE__ */ new Date();
  const firstDay = new Date(givenDate.getTime());
  const lastDay = new Date(givenDate.getTime());
  firstDay.setDate(givenDate.getDate() - [
    6,
    0,
    1,
    2,
    3,
    4,
    5
  ][givenDate.getDay()]);
  firstDay.setHours(0, 0, 0, 0);
  lastDay.setDate(givenDate.getDate() + [
    0,
    6,
    5,
    4,
    3,
    2,
    1
  ][givenDate.getDay()]);
  lastDay.setHours(23, 59, 59, 999);
  return {
    firstDay,
    lastDay
  };
}
function getDayRange(date) {
  const start = new Date(date);
  const end = new Date(date);
  start.setHours(0, 0, 0, 0);
  end.setHours(23, 59, 59, 999);
  return {
    end,
    start
  };
}
function getSecondsBetweenDates(start, end) {
  return (end.getTime() - start.getTime()) / 1e3;
}
function getToday() {
  const today = /* @__PURE__ */ new Date();
  today.setHours(0, 0, 0, 0);
  return today;
}
function getTodayISO() {
  const today = getToday();
  return today.toISOString().split("T")[0];
}
function getTodayAndTomorrow() {
  return {
    today: getToday(),
    tomorrow: getDateFromDate({ daysDiff: 1 })
  };
}
function getDateFromDate(params) {
  const dateObject = params.date ? new Date(params.date) : getToday();
  const dateFromDate = /* @__PURE__ */ new Date();
  dateFromDate.setHours(0, 0, 0, 0);
  dateFromDate.setDate(dateObject.getDate() + (params.daysDiff || 0));
  return dateFromDate;
}

export { convertHumanDateToTimestamp, format, fromNow, getDateFromDate, getDayNumber, getDayRange, getDaysBetweenTwoDates, getDaysRangeBetweenTwoDates, getFirstAndLastDayOfLastTwelveMonth, getFirstAndLastDayOfMonth, getFirstAndLastDayOfWeek, getSecondsBetweenDates, getToday, getTodayAndTomorrow, getTodayISO };
